import styled, { css } from 'styled-components';

import { Flex } from '@/components/Flex';

export const CTA = styled(Flex)`
  align-items: center;
  text-transform: uppercase;
  text-align: left;

  &:first-child {
    padding-top: 20px;
  }

  ${({ theme }) => css`
    padding-top: ${theme.spacing(2)};
    font-weight: ${theme.fontWeights.bold};
    font-size: ${theme.fontSizes.p2};
    color: ${theme.colors.primaryBlue};
    transition: ${theme.transitions.create('color')};

    &:hover {
      color: ${theme.colors.primary};
      cursor: pointer;
    }
  `}

  svg {
    margin-right: 10px;
    height: 18px;
  }
`;

/**
 * BEC-24926: a secondary CTA can be limited to one breakpoint - the PDP shows
 * Call to buy here on desktop and 4Gift here on mobile. Hidden with
 * `display: none` so the hidden row leaves the accessibility tree and the tab
 * order rather than being announced twice.
 */
export const Row = styled(Flex)<{ $hiddenOn?: 'desktop' | 'mobile' }>`
  ${({ $hiddenOn, theme }) => css`
    ${theme.media.md.down} {
      /* BEC-24926: every adjacent CTA sits 8px apart on mobile. The purchase
         buttons get that from CtaStack's gap, but these rows are its sibling,
         so they space themselves off the button's own 16px top margin. Applied
         to every row rather than the first: on mobile the first row in the DOM
         is the display:none Call to buy, which :first-child would target
         instead of the one the customer can see. Desktop keeps 16px. */
      && button {
        margin-top: ${theme.spacing(1)};
      }
    }

    ${$hiddenOn === 'mobile' &&
    css`
      ${theme.media.md.down} {
        display: none;
      }
    `}

    ${$hiddenOn === 'desktop' &&
    css`
      ${theme.media.md.up} {
        display: none;
      }
    `}
  `}
`;
